const Demir = resolve => {
    require.ensure(['../views/apps/demir/Demir'], () => {
        resolve(require('../views/apps/demir/Demir'))
    })
};
const Demirler = resolve => {
    require.ensure(['../views/apps/demir/Demirler'], () => {
        resolve(require('../views/apps/demir/Demirler'))
    })
};


import Vue from 'vue'
Vue.component('DemirFiyatlari', Demirler);

import layouts from '../layout'

export default {
    path: '/demir',
    name: 'demir',
    component: Demir,
    meta: {
        auth: true,
        layout: layouts.navLeft
    }

}
